import { render, staticRenderFns } from "./SiteMenu.vue?vue&type=template&id=0c999c38"
import script from "./SiteMenu.vue?vue&type=script&lang=js"
export * from "./SiteMenu.vue?vue&type=script&lang=js"
import style0 from "./SiteMenu.vue?vue&type=style&index=0&id=0c999c38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports